import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { DossierQuoteSyncInitResult } from "../../types/Quote";

type SyncQuotesPayload = {
  contactId: string;
  quoteId?: string;
};

export const syncQuotes = (options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const { defaultOnMutateError, defaultOnMutateSettled } = useAPQuery();

  return useMutation({
    mutationFn: (
      payload: SyncQuotesPayload
    ): Promise<DossierQuoteSyncInitResult> => {
      return fetchWithAuth<DossierQuoteSyncInitResult>(
        "syncQuotes",
        payload.contactId,
        {
          requestOptions: { method: "post", body: JSON.stringify(payload) },
        }
      );
    },
    onError: defaultOnMutateError(options),
    onSuccess: (result: DossierQuoteSyncInitResult, payload) => {
      let errorMessage: string | undefined;

      switch (result) {
        case "NO_ACTIVE_DOSSIER":
          errorMessage = "This contact has no active dossier.";
          break;
        case "CATCHE_DRIVER_NOT_LINKED":
          errorMessage = "This contact is not linked to a Catch-e driver";
          break;
      }

      const onError = defaultOnMutateError({
        ...options,
        mutationOptions: {
          ...options.mutationOptions,
          errorAlertMessage: errorMessage,
        },
      });

      if (result === "SYNCING") {
        defaultOnMutateSettled([["syncQuotesStatus", payload.contactId]]);
      } else {
        onError();
      }
    },
  });
};
